import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Container, Spinner, Alert, Modal, Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
export default function Artists() {
    const { user, logout } = useAuth();
    const [artists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [showArtistModal, setModal] = useState(false);
    const [selectedArtist, setSelectedArtist] = useState(null);
    const [editArtist, setEditArtist] = useState({
        name: "",
        email: "",
        phone_number: "",
    });
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone_number: "",
        facebook: "",
        youtube: "",
        apple_music: "",
    });
    // const [formDataEdit, setFormDataEdit] = useState({
    //     name: "",
    //     email: "",
    //     phone_number: "",
    // });
    const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
    const [message, setMessage] = useState("");
    useEffect(() => {
        // Early return if the user is not logged in
        if (!user.isLoggedIn) {
            return;
        }
        // Set the loading state to true
        setLoading(true);

        // Define the API URL based on the user's role
        const fetchUrl =
            user.role === 'super_admin' || user.role === 'admin'
                ? '/api/artists'
                : `/api/user/${user.user_id}/artists`;

        axios
            .get(baseUrl + fetchUrl)
            .then((response) => {
                setArtists(response.data.artists);
            })
            .catch((err) => {
                // setError('No Artists Found.');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [user]);
    const handleShowModal = (artist) => {
        setSelectedArtist(artist);
        setShowModal(true);
    };
    const handleEditModal = (artist) => {
        setEditArtist(artist);
        setEditModal(true);
    };
    const closeEditModal = () => {
        setEditModal(false);
    };    
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedArtist(null);
    };
    const addArtistModal = () => {
        setModal(true);
    }
    const CloseArtistModal = () => {
        setModal(false);
    };
    if (loading) {
        return (
            <Container className="text-center">
                <Spinner animation="border" variant="primary" />
                <p>Loading...</p>
            </Container>
        );
    }
    if (error) {
        return (
            <Container className="text-center">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEdit = (e) => {
        setEditArtist({ ...editArtist, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await axios.post("http://dawsonhighwaycafeandindiancuisine.com/api/add_artist.php", {
                'user_id': user.role == 'admin' ? 2 : user.user_id,
                'name': formData.name,
                'email': formData.email,
                'phone_number': formData.phone_number,
                'channels': JSON.stringify({
                    'facebook': formData.facebook,
                    'youtube': formData.youtube,
                    'apple_music': formData.apple_music,
                }),
            });
            if (response.data.status === 200) {
                setMessage(response.data.message);
                setFormData({
                    name: "",
                    email: "",
                    phone_number: "",
                    facebook: "",
                    youtube: "",
                    apple_music: "",
                });
            } else {
                setMessage("❌ Something went wrong!");
            }
        } catch (error) {
            setMessage("❌ Error submitting form!");
        } finally {
            setLoading(false);
        }
    };
    // Update
    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            const response = await axios.put(baseUrl + "/api/artists/" + editArtist.id, {
                'name': editArtist.name,
                'email': editArtist.email,
                'phone_number': editArtist.phone_number,
                'user_id': user.user_id,
            });
            if (response.data.status === 200) {
                setMessage(response.data.message);
                setEditArtist({
                    name: "",
                    email: "",
                    phone_number: "",
                });
                setEditModal(false);
                window.location.reload();
            } else {
                setMessage("❌ Something went wrong!");
            }
        } catch (error) {
            setMessage("❌ Error submitting form!");
        } finally {
            setLoading(false);
        }
    }
    //   Delete Artist
    const deleteArtist = async (id) => {
        const confirmSubmit = window.confirm("Are you sure you want to delete?");
        if (!confirmSubmit) return;
        try {
            const response = await axios.delete(baseUrl + `/api/artists/${id}`);
            if (response.data.status === 200) {
                setMessage(response.data.message);
                window.location.reload();
            } else {
                setMessage("❌ Failed to delete!");
            }
        } catch (error) {
            setMessage("❌ Error deleting data!");
        }
    }
    return (
        <div className='page_wrapper'>
            <div className='bg-dark text-white p-2'>
                <h5 class="mt-2" style={{ display: 'inline-block', width: "90%" }}>
                    All Artists
                </h5>
                <button type="button" class="btn btn-success" onClick={addArtistModal}>Add Artist</button>
                {/* <Button className="btn btn-outline-secondary" style={{ margin: '0 0 3px 0' }} >Add Artist</Button> */}
            </div>
            {message && <div className="alert alert-dark">{message}</div>}
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {artists.map((artist, index) => (
                        <tr key={artist.id || index}>
                            <td>{index + 1}</td>
                            <td>{artist.name}</td>
                            <td>{artist.email}</td>
                            <td>{artist.phone_number}</td>
                            <td>
                                <Button className="btn btn-xs" onClick={() => handleShowModal(artist)}><i class="bi bi-eye"></i></Button>
                                <Button className="btn btn-xs btn-warning" onClick={() => handleEditModal(artist)}><i class="bi bi-pencil-square"></i></Button>
                                <Button className="btn btn-xs btn-danger" onClick={() => deleteArtist(artist.id)}> <i class="bi bi-trash3"></i> </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {/* Modal to view selected artist details */}
            <Modal show={showModal} onHide={handleCloseModal} className="modal-lg">
                <Modal.Header className='bg-dark text-white' closeButton>
                    <Modal.Title>Artist Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedArtist ? (
                        <div>
                            <p><strong>Name:</strong> {selectedArtist.name}</p>
                            <p><strong>Email:</strong> {selectedArtist.email}</p>
                            <p><strong>Phone:</strong> {selectedArtist.phone_number}</p>
                        </div>
                    ) : (
                        <p>No artist selected.</p>
                    )}
                </Modal.Body>
                <Modal.Footer className='bg-dark text-white'>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Edit Modal */}
            <Modal show={editModal} onHide={closeEditModal} className="modal-lg">
                <Modal.Header className='bg-dark text-white' closeButton>
                    <Modal.Title>Edit Artist</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editArtist ? (
                        <form onSubmit={handleUpdate}>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                placeholder='Enter Name'
                                className="form-control"
                                name="name"
                                value={editArtist.name}
                                onChange={handleEdit}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={editArtist.email}
                                onChange={handleEdit}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input
                                type="tel"
                                className="form-control"
                                name="phone_number"
                                value={editArtist.phone_number}
                                onChange={handleEdit}
                                required
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success w-100">Update</button>
                        </div>
                    </form>
                    ) : (
                        <p>No artist selected.</p>
                    )}
                </Modal.Body>
                <Modal.Footer className='bg-dark text-white'>
                    <Button variant="secondary" onClick={closeEditModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Artist Modal */}
            <Modal show={showArtistModal} onHide={CloseArtistModal} className="modal-lg">
                <Modal.Header className='bg-dark text-white' closeButton>
                    <Modal.Title>Add Artist</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {message && <div className="alert alert-info">{message}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Enter Name'
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder='Enter Email'
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <input
                                type="tel"
                                className="form-control"
                                placeholder='Enter Number'
                                name="phone_number"
                                value={formData.phone_number}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Facebook</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Enter Facebook Link'
                                name="facebook"
                                value={formData.facebook}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Youtube</label>
                            <input
                                type="text"
                                className="form-control"
                                name="youtube"
                                placeholder='Enter Youtube Link'
                                value={formData.youtube}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Apple Music</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Enter Apple Music Link'
                                name="apple_music"
                                value={formData.apple_music}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success w-100">Submit</button>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer className='bg-dark text-white'>
                    <Button variant="secondary" onClick={CloseArtistModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
